import { EOtpModalActionTypes } from '../../actions/otpModal/actions';
import { TReduxActions } from '../../types/redux';

export function otpModalReducer(state: { open: boolean } = { open: false }, action: TReduxActions) {
  switch (action.type) {
    case EOtpModalActionTypes.OpenOtpModal:
      return {
        open: true,
      };

    case EOtpModalActionTypes.CloseOtpModal:
      return {
        open: false,
      };
    default:
      return state;
  }
}
